export default __webpack_public_path__ + "static/life-grid-yellow-min-60f659efd335ff51f63b812eb39e47f4.png";